export default "__VITE_ASSET__132db3e1__"